import {createFileRoute, useSearch} from '@tanstack/react-router'
import {WalletWithdraw} from "@/components/wallet/WalletWithdraw/WalletWithdraw.tsx"
import { z } from "zod";

const schema = z.object({
  id: z.string().optional(),
});


export const Route = createFileRoute('/_mainLayout/wallet/withdraw/')({
  component: RouteComponent,
  validateSearch: schema
})

function RouteComponent() {
  const params = useSearch({ from: "/_mainLayout/wallet/withdraw/" });
  return <WalletWithdraw {...params}/>
}
